import { render, staticRenderFns } from "./preview04.vue?vue&type=template&id=27c4dd2d&scoped=true"
import script from "./preview04.vue?vue&type=script&lang=js"
export * from "./preview04.vue?vue&type=script&lang=js"
import style0 from "./preview04.vue?vue&type=style&index=0&id=27c4dd2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c4dd2d",
  null
  
)

export default component.exports